import { IRON } from 'styles/Colors';
import { SET_DATA } from 'helpers/Constants';
import { TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { validateAction } from 'sharedActions/sharedActions';
import React, { useEffect, useState } from 'react';
import SocialSecurityNumberMask from 'components/rebrand/SocialSecurityNumberMask';

export default function RebrandBasicSocialSecurity({
  dataAttrs = {},
  id = 'socialSecurityNumber',
  name = 'socialSecurityNumber',
  label = 'Social Security Number'
}) {
  const [focus, setFocus] = useState(false);
  const [touched, setTouched] = useState(false);
  const value = useSelector((store) => store[id]);
  const error = useSelector((store) => store.errors[id]);
  const dispatch = useDispatch();
  useEffect(() => {
    if (value) {
      dispatch(validateAction(id));
    }
  }, [value]);

  const handleChange = async (e) => {
    const socialValue = e.target.value;
    dispatch({
      type: SET_DATA,
      payload: { [id]: socialValue }
    });

    if (touched || error) {
      dispatch(validateAction(id));
    }
  };
  const handleBlur = async () => {
    setFocus(false);
    setTouched(true);
    dispatch(validateAction(id));
  };

  return (
    <TextField
      css={{ width: '100%' }}
      id={id}
      name={name}
      label={label}
      type={focus ? 'text' : 'password'}
      variant='outlined'
      value={value}
      onFocus={() => setFocus(true)}
      onBlur={handleBlur}
      error={!!error}
      helperText={error}
      FormHelperTextProps={{ style: { margin: '0', fontSize: '12px' } }}
      InputLabelProps={{
        shrink: !!value || focus,
        style: { color: IRON }
      }}
      InputProps={{
        inputComponent: SocialSecurityNumberMask
      }}
      // eslint-disable-next-line react/jsx-no-duplicate-props
      inputProps={{
        'data-testid': 'ssn-input',
        ...dataAttrs
      }}
      onChange={handleChange}
    />
  );
}
